var React = require('react');
var PropTypes = React.PropTypes;
var moment = require('moment');
var request = require('superagent');
var env = require("../../utils/env");
var Helpers = require("../../utils/helpers");
var CollectionRes = require("../../resources/collection");
import '../../css/components/Exam/processing.css';
var apiDomain = env.domain.api;

import { Link } from 'react-router';
import async from 'async';
import $ from 'jquery';
var ReviewTaskRes = require('../../resources/review_task');

var ExamsTable = React.createClass({

	// show action buttons based on action in each mode of statusMode in ExamsManagement component
	actionByType: function(type, data) {
	    var _this = this;
			var result;
			type = type.toLowerCase();
			console.log(data.instance_status)
	    switch(type) {
	    	case 'edit':
		    	result = <Link to={"mock-exam/" + data._id}><button className="btn primary"><i className="fa fa-edit"></i>Edit</button></Link>;
		    	break;
	    	case 'publish':
		    	result = <button disabled={_this.props.isUpdating} className="btn"  onClick={_this.props.publishCollection.bind(this, data)}><i className="fa fa-upload"></i>Publish</button>;
		    	break;
	    	case 'reject':
		    	result = <button disabled={_this.props.isUpdating} className="btn negative" onClick={_this.props.rejectCollection.bind(this, data)}><i className="fa fa-times"></i>Reject</button>;
		    	break;
	    	case 'view':
	    		result = <Link to={"mock-exam/" + data._id}><button  className="btn negative"><i className="fa fa-eye"></i>View</button></Link>;
		    	break;
	    	case 'recover':
		    	result = <button disabled={_this.props.isUpdating} className="btn primary" onClick={_this.props.recoverCollection.bind(this, data)}><i className="fa fa-history"></i>Recover</button>;
		    	break;
	    	case 'new-ver':
		    	result = data.status === 'published' && data.instance_status === 'published' && <button disabled={_this.props.isUpdating} className="btn primary" onClick={_this.props.createNewVerCollection.bind(this, data)}><i className="fa fa-plus"></i>New Ver</button>;
					break;
				case 'processing':
		    	result = data.status === 'published' && data.instance_status === 'processing' &&<span className="processingText">Processing</span>;
					break;	
				case 'archived':
		    	result = data.status === 'published' && data.instance_status === 'archived' &&<span className="gray">Archived</span>;
		    	break;		
	    	default:
		    	result = null;
		    	break;
	    }
	    return result;
  	},

  	changeSort: function(chosenSort) {
  		var newSort;
  		if (this.state.sort.indexOf(chosenSort) >= 0) {
  			var sort = this.state.sort;
  			if (sort.charAt(0) === '-') newSort = sort.substr(1, sort.length);
  			else newSort = '-'  + sort;
  		} else {
  			newSort = '-' + chosenSort;
  		}
  		if (this.props.onSortChange && typeof this.props.onSortChange === 'function') {
  			this.props.onSortChange(newSort);
  		}
  	},

  	getSortIcon: function(currentSort) {
  		var ascSortIcon = <span className="fa fa-caret-up padding-left-5"></span>,
  		descSortIcon = <span className="fa fa-caret-down padding-left-5"></span>,
  		sortIcon = <span className="fa fa-sort padding-left-5"></span>,
  		sort = this.state.sort;
  		if (sort.indexOf(currentSort) >= 0) {
  			if (sort.charAt(0) === '-') return descSortIcon;
  			else return ascSortIcon;
  		} else {
  			return sortIcon;
  		}
  	},

  	getInitialState: function() {
	    return {
	      data: this.props.data,
	      conceptsMap: this.props.conceptsMap,
	      courses: this.props.courses,
	      mode: this.props.mode,
	      sort: this.props.sort
	    };
  	},

  	componentWillReceiveProps: function(nextProps) {
	    this.setState({
	      data: nextProps.data || this.state.data,
	      conceptsMap: nextProps.conceptsMap || this.state.conceptsMap,
	      mode: nextProps.mode || this.state.mode,
	      sort: nextProps.sort || this.state.sort
	    })
  	},


  	render: function() {
  		var _this = this;

  		return (
  			<div className="collection-table">
	            <table className="table table-bordered table-stripe">
	          		<thead>
			            <tr>
			            	<th className="sortable" onClick={this.changeSort.bind(this, 'title')}>
			              		Title
			              	{_this.getSortIcon('title')}
			            	</th>
			                <th className="sortable" onClick={this.changeSort.bind(this, 'subject')}>
			              		Subject
			              	{_this.getSortIcon('subject')}
			            	</th>
			                <th>Questions</th>
			            	<th>Marks</th>
			            	<th>Creator</th>
			            	<th className="sortable" onClick={this.changeSort.bind(this, 'dateCreated')}>
			              		Date Created
			              	{_this.getSortIcon('dateCreated')}
			            	</th>
			            	<th className="sortable" onClick={this.changeSort.bind(this, 'dateModified')}>
			              		Date Updated
			              	{_this.getSortIcon('dateModified')}
			            	</th>
			            	<th>Actions</th> 	
			            </tr>
	          		</thead>
	              	<tbody>
	              	{
	              		_this.props.data.map(function(exam, index) {
	              			return (
	              				<tr key={index}>
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''}>{exam.title}</td>
													{_this.state.courses ? <td className={exam.instance_status === 'processing' ? 'processing' : ''}>{_this.state.courses[exam.course]}</td> : <td className={exam.instance_status === 'processing' ? 'processing' : ''}></td> }
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''}>
		              				Total: {exam.total}<br />
		              					<span className='margin-left-10'>- MCQ: {exam.MCQ}</span><br />
		              					<span className='margin-left-10'>- SS: {exam.SS}</span><br />
		              					<span className='margin-left-10'>- LS: {exam.LS}</span>
		              				</td>
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''} >Total: {exam.totalScore}<br />
		              					<span className='margin-left-10'>- MCQ: {exam.MCQScore}</span><br />
		              					<span className='margin-left-10'>- SS: {exam.SSScore}</span><br />
		              					<span className='margin-left-10'>- LS: {exam.LSScore}</span>
		              				</td>
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''}>{exam.creatorName}</td>
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''}>{moment(exam.dateCreated).format("MM/DD/YYYY hh:mm A")}</td>
		              				<td className={exam.instance_status === 'processing' ? 'processing' : ''}>{moment(exam.dateModified).format("MM/DD/YYYY hh:mm A")}</td>
		              				<td className="action">
		              				{
		              					_this.state.mode.actions.map(function(action, index) {
		              						return (
		              							<div key={index} className="dp-inline-block">
		              								{_this.actionByType(action, exam)}
		              							</div>
	              							)
		              					})
		              				}
		              				</td>
	              				</tr>
              				)	
	              		})
	              	}
	              	</tbody>
	            </table>
          	</div>
		)
  	}



});

export default ExamsTable;


/** WEBPACK FOOTER **
 ** ./src/components/Exam/ExamsTable.js
 **/